<script lang="ts">
  import { type Component, untrack } from 'svelte';
  import { fa } from '../shared/i18n/fa';
  import { ErrorState, PulseLoader } from '../shared/ui';
  import { pageLoading } from './progress.svelte';
  import type { PageLoader } from './routes';

  /**
   * A page loaded on first use. Like React Router, the page on screen stays until the next one has
   * loaded; only the very first load shows «در حال بارگذاری». The route params go with the page, so
   * a page never sees the next page's params while that one loads. A wait longer than a moment
   * shows the app's top bar, so a tap never looks ignored (employer report 2026-10-15).
   */
  let { load, params = {} }: { load: PageLoader; params?: Record<string, string> } = $props();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let current = $state<{ page: Component<any>; params: Record<string, string> } | null>(null);
  let failed = $state<unknown>(null);
  let request = 0;

  $effect(() => {
    const loader = load;
    const next = params;
    request += 1;
    const mine = request;
    // Untracked: the count is written here, and this effect must not follow it.
    const done = untrack(() => pageLoading.start());
    loader().then(
      (mod) => {
        done();
        if (mine !== request) return;
        failed = null;
        current = { page: mod.default, params: next };
      },
      (error: unknown) => {
        done();
        if (mine !== request) return;
        // A page that failed to load (a chunk that did not arrive): the detail goes to the console.
        console.error(error);
        failed = error;
      },
    );
  });
</script>

{#if failed}
  <main class="mx-auto max-w-md px-4 py-16">
    <ErrorState error={new Error(fa.app.unknownError)} onRetry={() => window.location.reload()} />
  </main>
{:else if current}
  <!-- New params (another patient, another visit) are a fresh page, so nothing read once goes stale. -->
  {#key current}<div class="page-enter"><current.page params={current.params} /></div>{/key}
{:else}
  <PulseLoader page />
{/if}
